// extracted by css-extract-rspack-plugin
export default {"content":"content-CX0uF3","title":"title-_drjBz text-headline-sm","steps":"steps-bc_M63","stepNumber":"stepNumber-ecz_pj","stepText":"stepText-gtSEfB text-body-label"};